import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../envisia/auth/axios-http-client';
import {environment} from '../../../environments/environment';
import {
  ArticleMultilayerPlan,
  ArticleMultilayerPlanModel,
} from '../../envisia/article/main/multilayer-plan/article-multilayer-plan.models';
import {queryKey} from './multilayer-plan-query-keys';

interface Props {
  form: ArticleMultilayerPlanModel;
  sharedId?: string;
}

export function useMultilayerPlanUpdateMutation({form, sharedId}: Props) {
  const queryClient = useQueryClient();
  const {mutate, isPending, error, reset} = useMutation({
    mutationFn: () =>
      AxiosHttpClient.put<ArticleMultilayerPlan>(`${environment.apiv4uri}multilayerplan/${sharedId}`, form),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: queryKey.lists()});
      await queryClient.invalidateQueries({queryKey: queryKey.single(sharedId)});
    },
  });

  return {
    updateMutation: () => mutate(),
    updateIsPending: isPending,
    updateError: error,
    updateReset: () => reset(),
  };
}
